import { useState } from 'react';
import { getInkStyle, type InkColor } from '@/lib/ink-utils';

interface CardImageProps {
  src: string | null;
  alt: string;
  inkColor?: InkColor;
  enchanted?: boolean;
  showGlow?: boolean;
  className?: string;
}

export function CardImage({ src, alt, inkColor, enchanted, showGlow, className = '' }: CardImageProps) {
  const [loaded, setLoaded] = useState(false);
  const glowClass = showGlow && inkColor ? getInkStyle(inkColor).glow : '';

  return (
    <div className={`relative overflow-hidden rounded-lg ${glowClass} ${className}`}>
      {!loaded && <div className="skeleton-shimmer absolute inset-0" />}
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          className={`w-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        />
      ) : (
        <div className="flex aspect-[2/3] items-center justify-center bg-secondary text-4xl">🃏</div>
      )}
      {enchanted && (
        <div className="enchanted-sparkle absolute inset-0 pointer-events-none" />
      )}
    </div>
  );
}
